// ---------------------------------------------------------------------------
// PDM role model — single source of truth for role display labels (FR-39, FR-40).
//
// APIs, audit records, and telemetry persist the stable role IDs only
// (`pdm`, `pdm_manager`, `regional_leads`).
// ---------------------------------------------------------------------------

export type PdmRole = 'pdm' | 'pdm_manager' | 'regional_leads';

export const PDM_ROLES: readonly PdmRole[] = ['pdm', 'pdm_manager', 'regional_leads'] as const;

export const PDM_ROLE_LABELS = {
  pdm: 'PDM',
  pdm_manager: 'PDM manager',
  regional_leads: 'Regional leads',
} as const satisfies Record<PdmRole, string>;

export const PDM_ROLE_ADD_LABELS = {
  pdm: 'Add PDM',
  pdm_manager: 'Add PDM manager',
  regional_leads: 'Add regional leads',
} as const satisfies Record<PdmRole, string>;

/**
 * Resolves a stored role ID to its display label. Falls back to the raw ID for
 * forward compatibility if an unknown role ever appears in historical data.
 */
export const pdmRoleLabel = (role: string): string =>
  PDM_ROLE_LABELS[role as PdmRole] ?? role;
